import type { Project as GraftProject } from '@graft/nuget-gc.webportals.projects'

import type { Project } from '../types/project.types'

export async function projectToObject(entity: GraftProject): Promise<Project> {
  const [id, name, description, workspaceId, logo] = await Promise.all([
    entity.get_projectId(),
    entity.get_name(),
    entity.get_description(),
    entity.get_workspaceId(),
    entity.get_logoUrl(),
  ])
  return {
    id,
    name,
    description,
    workspaceId,
    logo,
  }
}
